import React from "react";
import { Box, Select as NBSelect } from "native-base";
import type { ISelectProps } from "native-base";
import { Platform } from "react-native";

const PLACEHOLDER_VALUE = "__placeholder__";

const baseSelectStyle: React.CSSProperties = {
  width: "100%",
  minHeight: 40,
  borderRadius: 6,
  border: "1px solid #E5E7EB",
  padding: "8px 12px",
  fontSize: 14,
  backgroundColor: "white",
};

const PlatformSelect = React.forwardRef<any, ISelectProps>((props, ref) => {
  const {
    children,
    selectedValue,
    defaultValue,
    onValueChange,
    placeholder,
    accessibilityLabel,
    isDisabled,
    isReadOnly,
    minWidth,
    width,
    maxWidth,
    flex,
    bg,
    backgroundColor,
  } = props;

  if (Platform.OS !== "web") {
    return (
      <NBSelect ref={ref} bg={bg ?? backgroundColor ?? "white"} {...props}>
        {children}
      </NBSelect>
    );
  }

  const value = selectedValue ?? defaultValue ?? "";
  const normalizedValue = value === "" ? PLACEHOLDER_VALUE : String(value);

  const options = React.Children.toArray(children).map((child: any, index) => {
    const label =
      child?.props?.label ?? child?.props?.children ?? String(child?.props?.value ?? index);
    const optionValue = child?.props?.value ?? String(index);
    return { label: String(label), value: String(optionValue) };
  });

  const resolvedBackgroundColor =
    typeof bg === "string"
      ? bg
      : typeof backgroundColor === "string"
        ? backgroundColor
        : "white";

  const selectStyle: React.CSSProperties = {
    ...baseSelectStyle,
    backgroundColor: resolvedBackgroundColor,
  };

  return (
    <Box minWidth={minWidth} width={width} maxWidth={maxWidth} flex={flex}>
      <select
        ref={ref}
        aria-label={accessibilityLabel || placeholder}
        disabled={isDisabled || isReadOnly}
        value={normalizedValue}
        onChange={(e) => onValueChange?.(e.target.value)}
        style={selectStyle}
      >
        {placeholder && (
          <option disabled value={PLACEHOLDER_VALUE}>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </Box>
  );
});

PlatformSelect.displayName = "PlatformSelect";

export default PlatformSelect;
